export default __webpack_public_path__ + "static/media/Ballroll_00104.204d8c44.png";